var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMeetIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 40.2188V46.875C44.9971 47.8687 44.6011 48.8208 43.8984 49.5234C43.1958 50.2261 42.2437 50.6221 41.25 50.625H16.875V39.375H33.75V30L45 40.2188Z",
    fill: "#00AC47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 20.625V40.2188L33.75 30V20.625H45Z",
    fill: "#31A950"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 9.375V20.625H5.625L16.875 9.375Z",
    fill: "#EA4435"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 20.625H5.625V41.25H16.875V20.625Z",
    fill: "#4285F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 13.125V20.625H44.0625L33.75 30V20.625H16.875V9.375H41.25C42.2437 9.37792 43.1958 9.77394 43.8984 10.4766C44.6011 11.1792 44.9971 12.1313 45 13.125Z",
    fill: "#FFBA00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 39.375V50.625H9.375C8.38134 50.6221 7.4292 50.2261 6.72657 49.5234C6.02394 48.8208 5.62792 47.8687 5.625 46.875V39.375H16.875Z",
    fill: "#0066DA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.375 15.4874V44.5124C54.375 44.8751 54.2698 45.23 54.072 45.534C53.8742 45.838 53.5924 46.0781 53.2608 46.225C52.9292 46.3719 52.5621 46.4194 52.2041 46.3617C51.846 46.304 51.5124 46.1436 51.2437 45.8999L45 40.2187L33.75 29.9999L44.0625 20.6249L45 19.7812L51.2437 14.0999C51.5124 13.8563 51.846 13.6958 52.2041 13.6381C52.5621 13.5804 52.9292 13.6279 53.2608 13.7748C53.5924 13.9218 53.8742 14.1618 54.072 14.4658C54.2698 14.7698 54.375 15.1247 54.375 15.4874Z",
    fill: "#00AC47"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45 19.7812V40.2188L33.75 30L44.0625 20.625L45 19.7812Z",
    fill: "#188038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeetIcon);
export default __webpack_public_path__ + "static/media/googleMeet-icon.8aa9d180b8a18ccaef77fc5c48e8633e.svg";
export { ForwardRef as ReactComponent };